import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7afc81f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-game-panel-content" }
const _hoisted_2 = {
  key: 0,
  class: "global-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "global-message" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "global-info-icon icon" }),
  /*#__PURE__*/_createElementVNode("p", { class: "text" }, " 星取表が崩れている場合は、試合内容を見直してください。 ")
], -1))
const _hoisted_4 = { class: "league-table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "チーム名", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 4,
  class: "season-game-panel-footer"
}
const _hoisted_11 = { class: "layout-inner -wide" }
const _hoisted_12 = { class: "footer-buttons" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-trash-alt icon" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" リーグ表を作り直す ")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CreateMatches = _resolveComponent("CreateMatches")!
  const _component_RequestGrouping = _resolveComponent("RequestGrouping")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.leagueTable.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (_ctx.existLeagueTable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_3,
              _createElementVNode("table", _hoisted_4, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_5,
                    _hoisted_6,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leagueTable.teams, (team) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: team.id
                      }, _toDisplayString(team.allocate_code), 1))
                    }), 128))
                  ]),
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leagueTable.teams, (team) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: team.id
                      }, _toDisplayString(team.team_short_name) + " " + _toDisplayString(team.division), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leagueTable.teams, (team, teamIndex) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: team.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(team.allocate_code), 1),
                      _createElementVNode("td", null, _toDisplayString(team.team_name) + " " + _toDisplayString(team.division), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leagueTable.formedGames[teamIndex], (game, gameIndex) => {
                        return (_openBlock(), _createElementBlock("td", { key: gameIndex }, [
                          game
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: {
                  name: 'seasonGameDetail',
                  params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: String(game.id) },
                  query: { group: game.group_id } }
                              }, {
                                default: _withCtx(() => [
                                  (game.match_no)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(game.match_no), 1))
                                    : _createCommentVNode("", true),
                                  (game.date)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(game.date), 1))
                                    : _createCommentVNode("", true),
                                  (game.team_score != null && game.opponent_score != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("span", null, _toDisplayString(game.result_marker), 1),
                                        _createTextVNode(" " + _toDisplayString(game.team_score) + " - " + _toDisplayString(game.opponent_score), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ], 64))
          : (_ctx.existEntryTeams)
            ? (_openBlock(), _createBlock(_component_CreateMatches, {
                key: 2,
                name: "対戦試合",
                onOnClickCreateButton: _ctx.createLeagueTable
              }, null, 8, ["onOnClickCreateButton"]))
            : (_openBlock(), _createBlock(_component_RequestGrouping, {
                key: 3,
                name: "対戦試合"
              })),
      (_ctx.existLeagueTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "global-button -small",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openLeagueDialogDelete && _ctx.openLeagueDialogDelete(...args)))
                }, _hoisted_15)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.leagueDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.leagueDialogDelete,
          onCloseDialog: _ctx.closeLeagueDialogDelete,
          onOnConfirm: _ctx.deleteGroupGames
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}